import GCarousel from "./g-carousel";

class CollectionProductsCarousel extends GCarousel {
  constructor() {
    super();
  }

  async connectedCallback() {
    await super.connectedCallback();
    await this.fetchItems();
  }

  async fetchItems() {
    const response = await fetch(this.url + `?section_id=ajax-collection-products-carousel&max_count=${this.maxCount}`);
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    const items = Array.from(tempDiv.querySelectorAll("#items .splide__slide")).map(
      (slide) => slide.outerHTML
    );

    if (items.length > 0) {
      this.splideList.innerHTML = items.join("");
      if(this.splide) {
        this.splide.refresh();
      }
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.setAttribute('aria-hidden', false);
  }

  hide() {
    this.setAttribute('aria-hidden', true);
  }

  get url() {
    return this.dataset.url;
  }

  get maxCount() {
    return Number(this.dataset.maxCount);
  }
}

customElements.define("collection-products-carousel", CollectionProductsCarousel);
